import { Inject, Injectable, Injector }from '@angular/core';


import { IntraOne_ds_get_shipment_details_by_shipping_container_idService } from './IntraOne.datasource.index';

@Injectable({ providedIn: 'root' })
export class IntraOne_DatasourceService {

  constructor(
    private injector: Injector
  ) {
  }

  public IntraOne: IntraOne_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_get_shipment_details_by_shipping_container_id: IntraOne_ds_get_shipment_details_by_shipping_container_idService;
  public get ds_get_shipment_details_by_shipping_container_id(): IntraOne_ds_get_shipment_details_by_shipping_container_idService {
    if(!this._ds_get_shipment_details_by_shipping_container_id) {
      this._ds_get_shipment_details_by_shipping_container_id = this.injector.get(IntraOne_ds_get_shipment_details_by_shipping_container_idService);
    }
    return this._ds_get_shipment_details_by_shipping_container_id;
  }
}

